/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import {
    ApiError400DefaultCodeEnum,
    ApiError404DefaultCodeEnum,
    ApiError500DefaultCodeEnum,
} from 'client-code/actions';

import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';

export class OfferContentScreenDetailsError extends AppError {
    public constructor(code: string, message: string) {
        super(code, message);
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ApiError400DefaultCodeEnum.ApigwError:
                this.type = ApiError400DefaultCodeEnum.ApigwError;
                this.code = ErrorTypes.OFFER_CONTENT_SCREEN_DETAILS_2001;
                break;
            case ApiError400DefaultCodeEnum.BadRequest:
                this.type = ApiError400DefaultCodeEnum.BadRequest;
                this.code = ErrorTypes.OFFER_CONTENT_SCREEN_DETAILS_2002;
                break;
            case ApiError404DefaultCodeEnum.ResourceNotFound:
                this.type = ApiError404DefaultCodeEnum.ResourceNotFound;
                this.code = ErrorTypes.OFFER_CONTENT_SCREEN_DETAILS_2003;
                break;
            case ApiError500DefaultCodeEnum.InternalServerError:
                this.type = ApiError500DefaultCodeEnum.InternalServerError;
                this.code = ErrorTypes.OFFER_CONTENT_SCREEN_DETAILS_2004;
                break;
            default:
                this.type = 'OFFER_CONTENT_SCREEN_DETAILS_UNKNOWN_ERROR';
                this.code = ErrorTypes.OFFER_CONTENT_SCREEN_DETAILS_2099;
        }
    }
}
